export const infraConfig = {
    apiEndpoint : "https://minsidadev-be.azurewebsites.net/api1",
    usePort: false,
    clientId: '0f7a3860-6f61-40a6-9684-65a00904e148', // minsida client
    identityServerEndpoint : "https://login.windows.net/portalplusdemo.onmicrosoft.com/v2.0/",
    documentsUrl: "https://minsidadev-be.azurewebsites.net/docs"
};

